import Phaser from 'phaser';
import { GAME_W, GAME_H, GAME_CX, GAME_CY } from './MobileHelper';

// === UTILITAIRE TRANSITIONS DE SCÈNES ===

/** Variantes de transition entre scènes */
export type SceneTransition = 'fade' | 'swipe' | 'radial';

/**
 * Lance une scène avec une transition.
 * - 'fade' (défaut) : fadeOut classique 200ms
 * - 'swipe' : voile noir qui balaye l'écran (action, ex. Map→Combat)
 * - 'radial' : cercle noir qui s'étend depuis le centre (moments forts, ex. Boss→Victory)
 */
export function startSceneWithFade(
  scene: Phaser.Scene,
  key: string,
  data?: object,
  transition: SceneTransition = 'fade',
): void {
  if (transition === 'swipe') {
    startSceneWithSwipe(scene, key, data);
    return;
  }
  if (transition === 'radial') {
    startSceneWithRadial(scene, key, data);
    return;
  }
  scene.cameras.main.fadeOut(200, 0, 0, 0);
  scene.cameras.main.once('camerafadeoutcomplete', () => {
    scene.scene.start(key, data);
  });
}

/** Voile noir qui balaye horizontalement de droite à gauche (250ms) */
function startSceneWithSwipe(scene: Phaser.Scene, key: string, data?: object): void {
  const veil = scene.add.rectangle(GAME_W + GAME_W / 2, GAME_CY, GAME_W, GAME_H, 0x000000)
    .setDepth(9999);
  scene.tweens.add({
    targets: veil,
    x: GAME_CX,
    duration: 250,
    ease: 'Power2',
    onComplete: () => scene.scene.start(key, data),
  });
}

/** Cercle noir qui s'étend depuis le centre pour couvrir l'écran (350ms) */
function startSceneWithRadial(scene: Phaser.Scene, key: string, data?: object): void {
  const veil = scene.add.circle(GAME_CX, GAME_CY, 1, 0x000000).setDepth(9999);
  const finalRadius = Math.ceil(Math.hypot(GAME_W, GAME_H) / 2 + 10);
  const proxy = { p: 0 };
  scene.tweens.add({
    targets: proxy,
    p: 1,
    duration: 350,
    ease: 'Power2',
    onUpdate: () => veil.setRadius(1 + finalRadius * proxy.p),
    onComplete: () => scene.scene.start(key, data),
  });
}
